import { useEffect } from 'react';
import { HotelRecord, Timeframe } from '../../../../common/types';
import {
  convertToKeenFriendlyHotelTimeframe,
  useKeenQuery,
} from '../../../../utils/keen';

const useOrderByCategoryData = ({
  hotel,
  timeframe,
}: {
  hotel: HotelRecord;
  timeframe: Timeframe;
}) => {
  const [
    {
      data: totalOrdersByCategory = [],
      loading: isTotalOrdersByCategoryLoading,
    },
    queryTotalOrdersByCategory,
  ] = useKeenQuery<{ categoryId: string; result: number }[]>();

  useEffect(() => {
    queryTotalOrdersByCategory({
      analysisType: 'count',
      eventCollection: 'orders',
      groupBy: 'category_id',
      filters: [
        {
          propertyName: 'hotel_id',
          operator: 'eq',
          propertyValue: hotel.id,
        },
        {
          propertyName: 'test_order',
          operator: 'eq',
          propertyValue: false,
        },
      ],
      timeframe:
        typeof timeframe === 'string'
          ? timeframe
          : convertToKeenFriendlyHotelTimeframe(timeframe, hotel.tzInfoId),
      timezone: hotel.tzInfoId,
    });
  }, [hotel.id, queryTotalOrdersByCategory, timeframe, hotel.tzInfoId]);

  return {
    data: totalOrdersByCategory,
    loading: isTotalOrdersByCategoryLoading,
  };
};

export default useOrderByCategoryData;
